import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { MainService } from "../../../../app.service";
import { DroneSecret } from "../../interfaces/drone-secret";
import { DroneUser } from "../../interfaces/drone-user";
import { DroneRepo } from "../../interfaces/drone-repo";

@Injectable({
  providedIn: "root",
})
export class DependencyTrackDroneService {
  constructor(
    private httpClient: HttpClient,
    private mainsService: MainService
  ) {}

  postDroneRepos(repo: string): Observable<DroneRepo> {
    return this.httpClient.post<DroneRepo>(
      `/dependency-tracker-extractor/v1/drone/repos/${repo}`,
      null,
      this.mainsService.httpOptions
    );
  }

  postDroneReposSecrets(
    repo: string,
    projectId: string
  ): Observable<Array<DroneSecret>> {
    return this.httpClient.post<Array<DroneSecret>>(
      `/dependency-tracker-extractor/v1/drone/repos/${repo}/secrets`,
      { project_id: projectId },
      this.mainsService.httpOptions
    );
  }

  deleteDroneReposSecrets(repo: string): Observable<void> {
    return this.httpClient.delete<void>(
      `/dependency-tracker-extractor/v1/drone/repos/${repo}/secrets`,
      this.mainsService.httpOptions
    );
  }

  getDroneUser(): Observable<DroneUser> {
    return this.httpClient.get<DroneUser>(
      `/dependency-tracker-extractor/v1/drone/user`,
      this.mainsService.httpOptions
    );
  }

  postDroneUserRepos(async: boolean): Observable<void> {
    return this.httpClient.post<void>(
      `/dependency-tracker-extractor/v1/drone/user/repos`,
      null,
      { ...this.mainsService.httpOptions, params: { async } }
    );
  }
}
